import { render, staticRenderFns } from "./HistoriaClinica.vue?vue&type=template&id=6da56a7a&"
import script from "./HistoriaClinica.vue?vue&type=script&lang=js&"
export * from "./HistoriaClinica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports